import PaymentRule from '@/services/paymentRule';

const state = {
  current: {
    period: {
      from: null,
      to: null,
    },
    value: null,
    expected_to: null,
  },
  payments: [],

};

const getters = {
  currentBalance: currentState => (currentState.current ? currentState.current : null),
  payments: currentState => (currentState.payments.length > 0 ? currentState.payments : []),
};

const actions = {
  async fetchBalanceData({ commit }) {
    const balanceData = await PaymentRule.getPaymentRule();
    commit('setBalanceData', balanceData);
  },
};

const mutations = {
  setBalanceData(currentState, balanceData) {
    Object.assign(currentState, balanceData);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
